import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap,asyncRouterMap } from './routerList'
Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  mode: 'history',
//   base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [...constantRouterMap,...asyncRouterMap]
})
